import React from 'react';
import { Redirect } from 'react-router';


class RedirectView extends React.Component {
  render() {
    return <Redirect to={this.props.destination} />;
  }
}


export default RedirectView;
